import styled from 'styled-components';
import { Col } from '@gv/triage-components';

export const StyledCol = styled(Col)<{ withoutMargin?: boolean }>`
  ${(p) => p.withoutMargin && `margin-bottom: 0`};
`;
